import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Authentication } from '../../services/authentication.service';
import { TitleService } from '../../services/title.service';

@Component({
  standalone: false,
  selector: 'app-signup-success',
  templateUrl: './signup-success.component.html',
  styleUrls: ['./signup-success.component.css'],
})
export class SignUpSuccessComponent implements OnInit {
  constructor(
    private authService: Authentication,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTabTitle();
    });
    if (this.authService.isTokenValid()) {
      this.router.navigate(['automap']);
    }
  }
  ngOnInit(): void {
    this.setTabTitle();
  }
  setTabTitle() {
    this.titleService.setTitle(this.activatedRoute.snapshot, this.router.routerState.snapshot);
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com/automap';
  }
}
